export default "__VITE_ASSET__CipLBXmv__"